var createBackoff = function createBackoff(_ref) {
  var _ref$min = _ref.min,
      min = _ref$min === void 0 ? 1000 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 5000 : _ref$max,
      _ref$jitter = _ref.jitter,
      jitter = _ref$jitter === void 0 ? 0.5 : _ref$jitter;
  var attempts = 0;
  return {
    duration: function duration() {
      var ms = min * Math.pow(2, attempts++);

      if (jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * jitter * ms);
        ms = (Math.floor(rand * 10) & 1) === 0 ? ms - deviation : ms + deviation;
      }

      return Math.min(ms, max) | 0;
    },
    reset: function reset() {
      attempts = 0;
    }
  };
};

export default createBackoff;
